module.exports = {"411421001":"绿洲街道","411421002":"南华街道","411421101":"人和镇","411421102":"龙塘镇","411421103":"北关镇","411421104":"程庄镇","411421105":"王庄寨镇","411421106":"孙六镇","411421107":"白云寺镇","411421108":"王桥镇","411421109":"庄子镇","411421110":"双塔镇","411421200":"伯党乡","411421201":"花园乡","411421204":"野岗乡","411421206":"林七乡","411421207":"胡集乡","411421208":"禇庙乡","411421210":"老颜集乡","411421400":"商丘市农场","411421401":"商丘市林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411421.json
// module id = 1511
// module chunks = 0